var _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormFieldErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10546"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Polygon 5",
    style: {
      fill: "#ed344e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.568 14.75H3.432c-.63 0-1.195-.325-1.512-.869a1.733 1.733 0 0 1-.01-1.744l5.067-8.943A1.73 1.73 0 0 1 8.5 2.307a1.73 1.73 0 0 1 1.523.887l5.067 8.943c.31.548.307 1.2-.01 1.744a1.733 1.733 0 0 1-1.512.869z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.557c-.547 0-1.035.284-1.305.76L2.127 12.26a1.486 1.486 0 0 0 .01 1.495c.27.467.755.745 1.295.745h10.136c.54 0 1.024-.278 1.296-.745a1.486 1.486 0 0 0 .009-1.495L9.805 3.317a1.483 1.483 0 0 0-1.305-.76m0-.5a1.98 1.98 0 0 1 1.74 1.014l5.068 8.943C16.063 13.347 15.1 15 13.568 15H3.432c-1.532 0-2.495-1.653-1.74-2.986L6.76 3.071A1.98 1.98 0 0 1 8.5 2.057z",
    style: {
      fill: "#de233d",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "!",
    transform: "translate(7.12 12.369)",
    style: {
      fill: "#fff",
      fontSize: 9,
      fontFamily: "Rubik-Bold,Rubik",
      fontWeight: 700
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormFieldErrorIcon);
export default __webpack_public_path__ + "static/media/form-field-error-icon.svg";
export { ForwardRef as ReactComponent };